import React from 'react'
import { useListSort } from '../../api/list.hooks'
import {
  SortableHeader as SharedSortableHeader,
  SortableHeaderProps,
} from 'shared/ui/Table/SortableHeader'

/**
 * Connects the shared sortable header UI to list sorting state.
 * @param title - Displayed header text
 * @param id - Sort field identifier
 */
export function SortableHeader({
  title,
  id,
}: Pick<SortableHeaderProps, 'title' | 'id'>) {
  const { field, order, sortToggle } = useListSort()

  return (
    <SharedSortableHeader
      title={title}
      id={id}
      isSorting={field === id}
      isAscending={order === 'asc'}
      onToggle={sortToggle}
    />
  )
}
